module.exports = __webpack_public_path__ + "static/img/dash-0.22c00a50.png";